import React, { useRef, Dispatch, SetStateAction, ChangeEvent } from 'react';
import {KTIcon} from '@/_metronic/helpers'

interface LookupProps {
  setTerms: Dispatch<SetStateAction<string | undefined>>;
}

const Lookup: React.FC<LookupProps> = ({ setTerms }) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      setTerms(value || undefined);
    }, 300);
  };

  return (
    <div className='d-flex align-items-center position-relative my-1'>
      <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
      <input
        type='text'
        data-kt-user-table-filter='search'
        className='form-control form-control-solid w-250px ps-14'
        placeholder="Search page ..."
        onChange={handleChange}
      />
    </div>
  );
};

export default Lookup;
